import Menu from './Menu.container';

export default Menu;
